import React from 'react';
import ServiceTemplate from './ServiceTemplate';
import { Speaker } from 'lucide-react';

const serviceData = {
  id: 'sonorisation',
  title: 'Sonorisation',
  description: 'Solutions audio professionnelles et systèmes de sonorisation',
  icon: Speaker,
  image: '/Sonorisation.jpg', // Updated path
  longDescription: [
    'Nos solutions de sonorisation professionnelle sont conçues pour offrir une qualité audio exceptionnelle dans tous types d\'environnements. De l\'installation à la maintenance, nous assurons une expérience sonore optimale.',
    'Nous proposons des systèmes adaptés à vos besoins spécifiques, que ce soit pour des salles de conférence, des espaces commerciaux ou des installations industrielles.'
  ],
  features: [
    'Installation de systèmes audio professionnels',
    'Sonorisation multizone',
    'Systèmes de conférence',
    'Solutions acoustiques sur mesure',
    'Intégration audiovisuelle complète',
    'Maintenance et support technique'
  ],
  benefits: [
    'Qualité sonore professionnelle',
    'Solutions personnalisées selon vos besoins',
    'Installation experte et soignée',
    'Maintenance préventive régulière',
    'Support technique réactif'
  ]
};

const Sonorisation = () => {
  return <ServiceTemplate service={serviceData} />;
};

export default Sonorisation;
